'use client';

import { useSearch } from '@/context/listing-search-provider';
import clsx from 'clsx';
import { ClientBrandConfig } from 'types/brand-config';

import DateSearch from '@/components/search/date-search';
import {
  SearchFieldLayout,
  SearchFieldRadius,
} from '@/components/search/search-config';

export type WhenFieldProps = {
  brand: ClientBrandConfig;
  id?: string;
  layout?: SearchFieldLayout;
  radius?: SearchFieldRadius;
  showDivider?: boolean;
  isLastInStack?: boolean;
  shouldSubmit?: boolean;
  submitPath?: string;
  numberOfMonths?: number;
  direction?: 'horizontal' | 'vertical';
  hideNavigation?: boolean;
  className?: string;
};

export const WhenField = ({
  brand,
  id = 'filter-dates',
  layout = 'stacked',
  radius = 'segment',
  showDivider = false,
  isLastInStack = false,
  shouldSubmit = false,
  submitPath,
  numberOfMonths = layout === 'stacked' ? 12 : 2,
  direction = 'horizontal',
  hideNavigation,
  className,
}: WhenFieldProps) => {
  const {
    applySearchParams,
    selectedDates,
    clearDateParams,
    setParam,
    flexDays,
  } = useSearch();

  return (
    <div
      className={clsx(
        'h-full',
        layout === 'stacked' && 'w-full',
        className
      )}
    >
      <DateSearch
        brand={brand}
        modal
        direction={direction}
        numberOfMonths={numberOfMonths}
        style="white"
        label="WHEN?"
        id={id}
        placeholder="Select dates"
        name="dates"
        shouldSubmit={shouldSubmit}
        submitPath={submitPath}
        hideNavigation={hideNavigation}
        applySearchParams={applySearchParams}
        clearDateParams={clearDateParams}
        selectedDates={selectedDates}
        setDateParam={setParam}
        flexDays={flexDays}
        searchField={{
          layout,
          radius,
          showDivider,
          isLastInStack,
        }}
      />
    </div>
  );
};
